import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { IconButton, Popover } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
//import PopupState, { bindTrigger, bindPopover} from 'material-ui-popup-state'

const HelpIconPopover = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const helpOpen = Boolean(anchorEl);
    const id = helpOpen ? 'simple-popover' : undefined;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return (

        <Box>

            <IconButton aria-describedby={id} aria-label="additional help text" variant="contained" style={{ color: 'rgba(0,0,0,0.54)', padding: '12px', borderRadius: '50%' }} onClick={handleClick}>
                <HelpIcon />
            </IconButton>
            <Popover
                        id={id}
                        open={helpOpen}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
            >
                <Typography style={{ maxWidth: '330px', padding: '10px' }} dangerouslySetInnerHTML={{ __html: props.Text }}></Typography>
            </Popover>
            </Box>

    )
}

export default HelpIconPopover;